import React, { useRef } from 'react';
import { Divider } from 'src/@vymo/ui/atoms';
import Text from 'src/@vymo/ui/atoms/text';
import { Card, NoData } from 'src/@vymo/ui/blocks';
import Form from 'src/@vymo/ui/molecules/form';
import {
  FormVersion,
  InputFieldConfig,
} from 'src/@vymo/ui/molecules/form/types';
import { Keys, locale } from 'src/i18n';
import { useAppSelector } from 'src/store/hooks';
import { DomainType, WorkflowType } from '../types';
import {
  getEntityDetailsInputsMap,
  getProfileCardFormValues,
  getProfileCardInputs,
} from './selectors';
import styles from './index.module.scss';

function ProfileCardDetails({
  inputs,
  domainType,
  workflowType,
}: {
  inputs: Array<InputFieldConfig>;
  domainType: DomainType;
  workflowType: WorkflowType;
}) {
  const formRef = useRef(null);
  const profileCardFormValues = useAppSelector((state) =>
    getProfileCardFormValues(state, {
      inputs,
      domainType,
      workflowType,
    }),
  );

  return (
    <div className={styles.details__profileCard__details}>
      {inputs?.length === 0 ? (
        <NoData message={locale(Keys.NO_PROFILE_FIELDS_FOUND)} />
      ) : (
        <Form
          ref={formRef}
          id="profileCardForm"
          name="profileCardForm"
          span="1fr"
          className={styles.details__profileCard__details__detail}
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onChange={(formFields) => {}}
          config={{
            version: FormVersion.webRevyre,
            data: inputs,
            seperator: ':',
            grouping: [],
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            viewMode: true,
          }}
          value={profileCardFormValues}
        />
      )}
    </div>
  );
}

function ProfileCard({ domainType, workflowType, entityId }) {
  const profileCardInputs = useAppSelector((state) =>
    getProfileCardInputs(state, domainType, workflowType, entityId),
  );

  const profileName = useAppSelector((state) =>
    getEntityDetailsInputsMap(state, entityId),
  )?.customerName;

  return (
    <Card data-test-id="details-profile-card">
      {profileName && (
        <>
          <div className={styles.details__profileCard__header}>
            <div className={styles.details__profileCard__header__avatar}>
              <Text type="h4">
                {profileName && profileName[0].toUpperCase()}
              </Text>
            </div>
            <Text data-test-id="profile-card-name" type="h4">
              {profileName}
            </Text>
          </div>
          <Divider />
        </>
      )}
      {profileCardInputs?.headerInputs?.length ||
      profileCardInputs?.bodyInputs?.length ? (
        <>
          <ProfileCardDetails
            inputs={profileCardInputs?.headerInputs}
            domainType={domainType}
            workflowType={workflowType}
          />
          <Divider />
          <ProfileCardDetails
            inputs={profileCardInputs?.bodyInputs}
            domainType={domainType}
            workflowType={workflowType}
          />
        </>
      ) : (
        <NoData message={locale(Keys.NO_PROFILE_FIELDS_FOUND)} />
      )}
    </Card>
  );
}

export default ProfileCard;
